import { all, call, put, takeLatest } from "redux-saga/effects";

import { getRegionData, updateRegionData } from "./appActions";
import appServices from "./appServices";

function* getRegionDataSaga() {
  try {
    const [countries, states, cities] = yield all([
      call(appServices.getCountries),
      call(appServices.getStates),
      call(appServices.getCities),
    ]);

    yield put(updateRegionData({ cities, countries, states }));
  } catch (error: any) {
    console.log("activelinxx debug", "getRegionDataSaga failed", error);
  }
}

export default function* () {
  yield takeLatest(getRegionData, getRegionDataSaga);
}
